import { useState } from 'react';
import Activate from './Activate';
import Revoke from './Revoke';
import Renew from './Renew';
import AllKeys from './AllKeys';
import { PrimaryButton } from '../components/Button';
import Lookup from './Lookup';
import SelectTenant from './SelectTenant';


function MainPage({tenant, selectTenant}) {
  const [activeMode, setActiveMode] = useState('');

  switch (activeMode) {
    case 'Register':
      return <Activate tenant={tenant} onDone={() => setActiveMode('')} />;
    case 'Renew':
      return <Renew tenant={tenant} onDone={() => setActiveMode('')} />;
    case 'Revoke':
      return <Revoke tenant={tenant} onDone={() => setActiveMode('')} />;
    case 'Lookup':
      return <Lookup tenant={tenant} onDone={() => setActiveMode('')} />;
    case 'AllKeys':
      return <AllKeys tenant={tenant} onDone={() => setActiveMode('')} />;

    default:
      return <MainMenu tenant={tenant} selectTenant={selectTenant} setActiveMode={setActiveMode} />;

  }
}

function MainMenu({ tenant, selectTenant, setActiveMode }) {
  return (
    <div>
      <SelectTenant tenant={tenant} setTenant={selectTenant} />
      <div>
        <PrimaryButton disabled={!tenant} onClick={() => setActiveMode('Register')}>Activate</PrimaryButton>
        <PrimaryButton disabled={!tenant} onClick={() => setActiveMode('Renew')}>Renew</PrimaryButton>
        <PrimaryButton disabled={!tenant} onClick={() => setActiveMode('Revoke')}>Revoke</PrimaryButton>
        <PrimaryButton disabled={!tenant} onClick={() => setActiveMode('Lookup')}>Lookup</PrimaryButton>
        <PrimaryButton disabled={!tenant} onClick={() => setActiveMode('AllKeys')}>All Keys</PrimaryButton>
      </div>
    </div>
  );
}

export default MainPage;